export default "__VITE_ASSET__j04pOJPo__"